import { SimpleDate } from './simple-date.model';

export class MonthPeriod {

  year: number;
  month: number;

  constructor(date: SimpleDate) {
    this.year = date.year;
    this.month = date.month !== undefined ? date.month : 1;
  }

  toString(): string {
    const monthStr = this.month < 10 ? '0' + this.month : '' + this.month;
    return `${this.year}${monthStr}`;
  }
}
